import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import {
  generateKey,
  independentFunction,
  verifyData,
} from "../../../pages/Common/CommonFunctions/commonFunctions";
import { withTranslation } from "react-i18next";

const RightSide = (props) => {
  const [menu, setMenu] = useState([]);
  const [rightMenus, setRightMenus] = useState([]);

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("authUser"));
    if (verifyData(obj)) {
      let array = obj?.headerMenu?.rightMenus;

      // Add null/undefined check before sorting
      if (array && Array.isArray(array)) {
        array = array.sort(function (a, b) {
          return a?.priority - b?.priority;
        });
        setRightMenus(array);
        let newMenu = array.map((eachMenu) => {
          return false;
        });
        setMenu(newMenu);
      } else {
        // If array is null/undefined, set empty arrays
        setRightMenus([]);
        setMenu([]);
      }
    }
  }, []);

  const toggle = (index) => {
    let newArray = [...menu];
    newArray = newArray.map((eachMenu, i) => {
      if (index == i) {
        return !eachMenu;
      } else {
        return eachMenu;
      }
    });
    setMenu(newArray);
  };

  return (
    <>
      {rightMenus.length > 0
        ? rightMenus
            .filter(
              (option) =>
                !(option.image != null && option.image !== "") &&
                option?.icon !== "mdi-settings-outline",
            )
            .map((option, index) => (
              <React.Fragment key={generateKey(index)}>
                {option?.subMenus?.length > 0 ? (
                  <Dropdown
                    isOpen={menu[index]}
                    toggle={() => toggle(index)}
                    className="d-sm-inline-block"
                    id={"as-menu-dropdown-" + index}
                  >
                    <DropdownToggle
                      className="btn header-item noti-icon right-bar-toggle waves-effect"
                      tag="button"
                    >
                      <i className={`mdi ${option?.icon}`} />
                      <span
                        id={
                          "as-menu-" +
                          option?.name.toLowerCase().replaceAll(" ", "-")
                        }
                      >
                        {props.t(option?.name)}
                      </span>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end" end>
                      {option?.subMenus
                        ?.sort((a, b) => a?.priority - b?.priority)
                        ?.map((subMenu) => (
                          <DropdownItem key={generateKey(subMenu.id)}>
                            {subMenu?.urlType == "EXTERNAL" ? (
                              <a
                                target="_blank"
                                href={subMenu?.url}
                                id={
                                  "as-menu-" +
                                  option?.name
                                    .toLowerCase()
                                    .replaceAll(" ", "-")
                                }
                              >
                                {props.t(subMenu?.name)}
                              </a>
                            ) : (
                              <Link
                                to={subMenu?.url}
                                id={
                                  "as-menu-" +
                                  subMenu?.name
                                    .toLowerCase()
                                    .replaceAll(" ", "-")
                                }
                              >
                                {props.t(subMenu?.name)}
                              </Link>
                            )}
                          </DropdownItem>
                        ))}
                    </DropdownMenu>
                  </Dropdown>
                ) : (
                  <Link
                    key={generateKey(index)}
                    to={option.url}
                    className={independentFunction(
                      window?.location?.pathname === "/migration",
                      "migration-link-active",
                      "migration-link",
                    )}
                    id={
                      "as-menu-" +
                      option?.name.toLowerCase().replaceAll(" ", "-")
                    }
                  >
                    <span>{props.t(option?.name)}</span>
                  </Link>
                )}
              </React.Fragment>
            ))
        : ""}
    </>
  );
};

RightSide.propTypes = {
  t: PropTypes.any,
};

const mapStatetoProps = null;

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(RightSide)),
);
